import { render, staticRenderFns } from "./DoitemForm.vue?vue&type=template&id=5225dc0c&scoped=true"
import script from "./DoitemForm.vue?vue&type=script&lang=js"
export * from "./DoitemForm.vue?vue&type=script&lang=js"
import style0 from "./DoitemForm.vue?vue&type=style&index=0&id=5225dc0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5225dc0c",
  null
  
)

export default component.exports